import { render, staticRenderFns } from "./UserPermissionModal.vue?vue&type=template&id=692ad2d3&scoped=true&"
import script from "./UserPermissionModal.vue?vue&type=script&lang=js&"
export * from "./UserPermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionModal.vue?vue&type=style&index=0&id=692ad2d3&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-2fffd51942/0/cache/vue-loader-npm-15.9.3-4ca89c7e4b-bc7d4c63e0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692ad2d3",
  null
  
)

export default component.exports